<template>
  <AppContainer justify-center>
    <EHeroContent :title :description :icon variant="danger" />
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useGoBack } from '@/composables/useGoBack.js'
import { useAppStore } from '@/stores/AppStore'
import { EHeroContent } from '@expansivefm/eds'
import { computed, onMounted } from 'vue'

const { resetGoBack } = useGoBack()

const appStore = useAppStore()

const icon = computed(() => appStore.errorIcon)
const title = computed(() => appStore.errorTitle)
const description = computed(() => appStore.errorMessage)

onMounted(() => {
  resetGoBack()

  appStore.$patch({ showBackButton: true })
})
</script>
